(() => {
  if (customElements.get('amazon-store')) return;
  const storageKey = 'amazear-amazon-market';
  const countryKey = 'amazear-visitor-country-v1';
  const countryTtl = 30 * 60 * 1000;
  let countryRequest;
  const countryCode = value => typeof value === 'string' && /^[A-Za-z]{2}$/.test(value) ? value.toUpperCase() : '';
  const marketForCountry = value => {
    const code = countryCode(value).toLowerCase();
    return code === 'gb' ? 'uk' : code;
  };
  const manualMarket = () => {
    try { return sessionStorage.getItem(storageKey) || ''; } catch (_) { return ''; }
  };
  const detectCountry = rootUrl => {
    if (countryRequest) return countryRequest;
    try {
      const cached = JSON.parse(sessionStorage.getItem(countryKey));
      const age = Date.now() - cached?.checkedAt;
      if (countryCode(cached?.country) && age >= 0 && age < countryTtl) {
        countryRequest = Promise.resolve(countryCode(cached.country));
        return countryRequest;
      }
    } catch (_) { /* Missing/blocked storage does not prevent detection. */ }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    const root = (rootUrl || '/').replace(/\/?$/, '/');
    countryRequest = fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal
    }).then(response => response.ok ? response.json() : null).then(data => {
      const country = countryCode(data?.detected_values?.country?.handle);
      if (country) {
        try { sessionStorage.setItem(countryKey, JSON.stringify({ country, checkedAt: Date.now() })); } catch (_) { /* Cache is optional. */ }
      }
      return country;
    }).catch(() => '').finally(() => clearTimeout(timeout));
    return countryRequest;
  };
  class AmazonStore extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const select = this.querySelector('[data-amazon-market]');
      const link = this.querySelector('[data-amazon-purchase]');
      if (!select || !link) return;
      this.initialized = true;
      const options = Array.from(select.options);
      const choose = market => {
        const index = options.findIndex(option => option.dataset.market === market);
        if (index < 0) return false;
        select.selectedIndex = index;
        return true;
      };
      const hasManualPreference = choose(manualMarket());
      if (!hasManualPreference) choose(marketForCountry(this.dataset.localizationCountry));
      const update = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        link.href = option.value;
        link.setAttribute('aria-label', `Shop ${this.dataset.productTitle} on Amazon ${option.dataset.label} (opens in a new tab)`);
        this.querySelectorAll('[data-amazon-price-market]').forEach(price => {
          price.hidden = price.dataset.amazonPriceMarket !== option.dataset.market;
        });
      };
      update();
      select.addEventListener('change', () => {
        this.manuallyChosen = true;
        update();
        try { sessionStorage.setItem(storageKey, select.options[select.selectedIndex].dataset.market); } catch (_) { /* Keep the selected link usable. */ }
      });
      select.closest('.amazon-links__market-control').hidden = false;
      this.classList.add('amazon-links--ready');
      if (!hasManualPreference) {
        detectCountry(this.dataset.rootUrl).then(country => {
          // Never let a slow response overwrite a choice made while loading,
          // including a choice from another product widget on the same page.
          if (this.manuallyChosen || !this.isConnected) return;
          if (choose(manualMarket()) || choose(marketForCountry(country))) update();
        });
      }
    }
  }
  customElements.define('amazon-store', AmazonStore);
})();
